import { Component, effect, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { DataAccessService } from 'src/app/shared/services/data-access/data-access.service';
import { DataRepositoryService } from 'src/app/shared/services/data-repository/data-repository.service';
import { TaskInfoService } from 'src/app/shared/services/task-info/task-info.service';
import { PlannedComponent } from './planned/planned.component';
import { TaskSource, TBTabName } from 'src/app/shared/models/core';
import { PlannedPbmComponent } from './planned-pbm/planned-pbm.component';
import { UnplannedComponent } from './unplanned/unplanned.component';
import { Option } from 'src/app/shared/models/favourite';
import { UnloadedComponent } from './unloaded/unloaded.component';
import { TaskMovementService } from 'src/app/shared/services/operations/task-movement.service';
import { MenuItem, MessageService } from 'primeng/api';
import { UpdateAddressService } from 'src/app/shared/components/add-address/update-address.service';
import { PushToCloudComponent } from './push-to-cloud/push-to-cloud.component';
import { TaskbankColumnService } from './column-service/taskbank-column.service';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { DateFormatPipe, DateFormatType } from 'src/app/shared/pipe/date-format-pipe/date-format.pipe';
import { ErrorMessage, ErrorType } from 'src/app/shared/entity/error.const';
import { SortingService } from 'src/app/shared/services/operations/sorting.service';
import { ColumnPreference } from 'src/app/shared/models/column-preference';
import TaskBankJSON from 'src/assets/data/taskbank.json'
import { ColumnPreferenceTab } from 'src/app/modules/setting/column-preference/column-preference.component';
import { UserColumnPreferencesService } from 'src/app/modules/setting/column-preference/user-column-preferences-service/user-column-preferences.service';
import { ColumnService } from 'src/app/shared/services/column-services/column.service';
import { SelectedPreferencesENUM } from 'src/app/shared/models/preference';

@Component({
    selector: "app-task-bank",
    templateUrl: "./task-bank.component.html",
    styleUrls: ["./task-bank.component.scss", '../../../../shared/css/primeng-dropdown.component.scss'],
    standalone: false
})
export class TaskBankComponent implements OnInit {
  isUpdateStateDisable: boolean = false;
  activeItem: MenuItem | undefined;
  showColumnConfig = false;
  selectedOption: Option | undefined;
  blName = "";
  offset: number;
  etag: number;
  status: string;
  @Output() sectionFullScreen = new EventEmitter();
  isFullScreen: boolean = false;
  tabName = TBTabName;
  searchText: string = "";
  isColumnConfigVisible: boolean = false;
  selectedTab: string;
  columnList: ColumnPreference[] = [];
  selectedTaskBankListValue: ColumnPreference = {} as ColumnPreference;
  @ViewChild(PlannedComponent) plannedComponent: PlannedComponent;
  @ViewChild(PlannedPbmComponent) plannedPbmComponent: PlannedPbmComponent;
  @ViewChild(UnplannedComponent) unplannedComponent: UnplannedComponent;
  @ViewChild(UnloadedComponent) unloadedComponent: UnloadedComponent;
  @ViewChild(PushToCloudComponent) pushToCloudComponent: PushToCloudComponent;

  constructor(
    public taskInfoService: TaskInfoService,
    public dataAccessService: DataAccessService,
    public taskMovementService: TaskMovementService,
    public updateAddressService: UpdateAddressService,
    public dataRepositoryService: DataRepositoryService,
    private readonly taskBankColumnService: TaskbankColumnService,
    private readonly dateFormatPipe: DateFormatPipe,
    private readonly messageService: MessageService,
    private readonly userColumnPreferenceService: UserColumnPreferencesService,
    private readonly columnService: ColumnService,
    private readonly sortingService: SortingService
  ) {
    this.listnerColumnListEffect();
    this.selectedColumnEffect();
  }

  /**
   * This effect checks selected list from dropdown and updates the same.
  */
  selectedColumnEffect() {
    effect(() => {
      if (this.dataRepositoryService.tempSelectedUserColumnPreferences()?.[
        SelectedPreferencesENUM.TASKBANK
      ]) {
        let taskBankSelectedPreference:ColumnPreference =
          this.dataRepositoryService.tempSelectedUserColumnPreferences()?.[
          SelectedPreferencesENUM.TASKBANK
          ]??{} as ColumnPreference;
        taskBankSelectedPreference.columnList = this.taskBankColumnService.mergeSavedColumns(TaskBankJSON, taskBankSelectedPreference?.columnList??[])
        this.selectedTaskBankListValue = taskBankSelectedPreference??this.taskBankColumnService.generateDefaultColumnList();
      }else {
        //set the default column list as selected value
        this.selectedTaskBankListValue = this.taskBankColumnService.generateDefaultColumnList();
      }
    });
  }

  /**
   * this effect checks list of column preferences created and updates the list.
  */
  listnerColumnListEffect() {
    effect(() => {
      if (this.dataRepositoryService.userColumnPreferencesList().length){
        const userPrefs = this.dataRepositoryService.userColumnPreferencesList().filter(
          (e) =>
            e.type?.toLowerCase() ===
            ColumnPreferenceTab.TASKBANK.toLowerCase()
        );
        const combinedList = [...userPrefs.filter(x => x.type?.toLowerCase() === ColumnPreferenceTab.TASKBANK.toLowerCase())]
        this.columnList = combinedList;
      }
    });
  }

  ngOnInit(): void {
  }

  /**
   *
   * The 'fullScreen' method toggles fullscreen mode and emits an events with the fullscreen state.
   */
  fullScreen(fs: boolean) {
    this.isFullScreen = fs;
    this.sectionFullScreen.emit(fs);
  }

  /**
   * The 'clearSearch' method resets the search text to an empty string.
   */
  clearSearch() {
    this.searchText = "";
  }

  /**
   * This method is used to export data to PDF downloadable file.
   */
  exportPDF() {
    switch (this.taskInfoService.selectedTabName) {
      case this.tabName.PlannedPBM:
        this.downloadPDF(this.tabName.PlannedPBM);
        break;
      case this.tabName.Unplannedpickup:
        this.downloadPDF(this.tabName.Unplannedpickup);
        break;
      default:
    }
  }

  /***
   * This method returns PBM source tasks
   */
  getPrintData(tabName: string) {
    let filteredPBMTasks: any[] = [];
    if (this.taskMovementService.selectedOptionsForTaskMove?.length) {
      filteredPBMTasks = [
        ...this.taskMovementService.selectedOptionsForTaskMove,
      ];
    } else {
      filteredPBMTasks =
        tabName === this.tabName.PlannedPBM
          ? [...this.dataRepositoryService.plannedPbmTbCollection.values()]
          : [...this.dataRepositoryService.unplannedTbCollection.values()];
    }

    filteredPBMTasks = filteredPBMTasks.filter(
      (task: any) =>
        task?.source?.toLowerCase() === TaskSource.PBM.toLowerCase()
    );
    
    return filteredPBMTasks.map((task: any) => ({
      ...task,
      task_time_window: task.task_time_window ?? ""
    }));

  }

  /**
   * This method is used to export data to PDF downloadable file.
   */
  downloadPDF(tabName: string) {
    const taskBankSelectedPreference = this.dataRepositoryService.tempSelectedUserColumnPreferences()?.[SelectedPreferencesENUM.TASKBANK];
    const printData = this.getPrintData(tabName);
    if (!printData || printData.length === 0) {
      this.messageService.add({
        severity: ErrorType.ERROR,
        closable: false,
        summary: "",
        detail: ErrorMessage.NODATA,
      });
      return;
    }
    const doc: any = new jsPDF({
      orientation: "landscape",
      unit: "pt",
    });

    const cols = this.taskBankColumnService.getVisibleColumns(tabName, taskBankSelectedPreference?.columnList??[])
      .filter((col) =>
        this.taskBankColumnService.columnPrint.includes(col.field)
      )
      .map((col) => ({
        dataKey: col.field,
        header: col.label,
      }));
    autoTable(doc, {
      columns: cols,
      body: printData,
      styles: { fontSize: 7, overflow: "linebreak", cellPadding: 2 },
      columnStyles: {
        driver_instruction: { cellWidth: 70, overflow: "linebreak" },
        route_name: { cellWidth: 30, overflow: "linebreak" },
        task_point_name: { cellWidth: 70, overflow: "linebreak" },
        address: { cellWidth: 70, overflow: "linebreak" },
        delivery_point_area_name: { cellWidth: 30, overflow: "linebreak" },
      },
    });
    doc.save(`${tabName}Tasks_${new Date().toDateString()}.pdf`);
  }

  /**
   *
   *  The 'filterData' method applies filtering to different components based on the selected tab name.
   */
  filterData($event: any) {
    switch (this.taskInfoService.selectedTabName) {
      case this.tabName.Planned:
        this.plannedComponent.filterData($event);
        break;
      case this.tabName.PlannedPBM:
        this.plannedPbmComponent.filterData($event);
        break;
      case this.tabName.Unplannedpickup:
        this.unplannedComponent.filterData($event);
        break;
      case this.tabName.Unloaded:
        this.unloadedComponent.filterData($event);
        break;
      case this.tabName.PushToCloud:
        this.pushToCloudComponent.filterData($event);
        break;
      default:
    }
  }

  setDefaultSorting() {
    if (this.dataRepositoryService.plannedTbCollection.size > 0) {
      this.taskInfoService.multiSortMeta = [
        { field: "route_name", order: 1 },
        { field: "stop_sequence", order: 1 },
        { field: "task_sequence", order: 1 }
      ];
    }
  }

  /**
   * clearSearch() call the method to reset or clear any search-related input,
   * call the 'filterData(null)' method with null as an argument to reset or remove any applied filter.
   */
  clearSearchAndReset() {
    this.clearSearch();
    this.filterData(null);
  }

  /**
   * Icon update for selected tab only.
   * @param $event on selected tab option
   */
  switchTAB(index: number | string | undefined) {
    const tab = this.taskInfoService.taskBankTabs[index as number];
    if (this.taskInfoService.activeIndex !== tab) {
      this.activeItem = tab;
      this.taskInfoService.switchTAB(tab);
      this.sortingService.resetingCustomSorting();
      this.clearSearch();
    }
  }

  handleColumnListChange($event: {
    selectedList: ColumnPreference;
    tempUpdate?: boolean;
  }) {
    this.columnService.setUserColumnPreference(
      SelectedPreferencesENUM.TASKBANK,
      $event.selectedList,
      $event?.tempUpdate ?? false
    );
  }
}